import { render, staticRenderFns } from "./FormLogin.vue?vue&type=template&id=052bf062&scoped=true&"
import script from "./FormLogin.vue?vue&type=script&lang=ts&"
export * from "./FormLogin.vue?vue&type=script&lang=ts&"
import style0 from "./FormLogin.vue?vue&type=style&index=0&id=052bf062&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052bf062",
  null
  
)

export default component.exports